import { useState, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

export function useMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (document.body.offsetWidth <= 1200) setIsMobile(true);
  }, []);

  return [isMobile, setIsMobile];
}

export function isMobile(ctx) {
  const userAgent = ctx.req.headers['user-agent'] || '';
  return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|Mobile/i.test(userAgent);
}

export function isWebKit() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent;

  const isWebKitEngine =
    /AppleWebKit/.test(ua) && !/Chrome\/|Chromium\/|Edg\/|OPR\//.test(ua);

  return isWebKitEngine;
}

export function useTracking(me, trackView, updateLastSeen) {
  const router = useRouter();
  const didInitialRef = useRef(false);

  const trackCore = (url) => {
    const path = url.split('?')[0];
    const contentUri =
      path === '/' ? '/' : path.split('/').filter(Boolean).pop();

    trackView({ variables: { contentUri } });

    if (me?.username) updateLastSeen();
  };

  const trackMatomo = (url) => {
    if (typeof window === 'undefined' || !window._paq) return;

    const full = new URL(url, window.location.origin);

    window._paq.push(['setCustomUrl', full.href]);
    window._paq.push(['setDocumentTitle', document.title]);

    for (const [key, value] of full.searchParams.entries()) {
      const m = key.match(/^dimension(\d+)$/);
      if (m && value) {
        window._paq.push(['setCustomDimension', parseInt(m[1], 10), value]);
      }
    }

    if (typeof window.applyAttribution === 'function') window.applyAttribution();

    window._paq.push(['trackPageView']);
  };

  useEffect(() => {
    if (!router.isReady) return;
    if (didInitialRef.current) return;

    didInitialRef.current = true;
    trackCore(router.asPath);
  }, [router.isReady, router.asPath, me?.username, trackView, updateLastSeen]);

  useEffect(() => {
    const handleRouteChange = (url) => {
      trackCore(url);
      trackMatomo(url);
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, me?.username, trackView, updateLastSeen]);
}
